import { render, staticRenderFns } from "./PayType.vue?vue&type=template&id=5fef3703&scoped=true"
import script from "./PayType.vue?vue&type=script&lang=js"
export * from "./PayType.vue?vue&type=script&lang=js"
import style0 from "./PayType.vue?vue&type=style&index=0&id=5fef3703&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef3703",
  null
  
)

export default component.exports